import React, { useEffect, useState } from "react";
import VaultexLogo from "../../Assets/vaultex-logo.svg";
import { Link, useLocation } from "react-router-dom";
import { routeList } from "../../Config/routeConfig";
import { getBrands } from "../../services/admin/brand";

export const Header = () => {
    const location = useLocation();
    const navigationItems = routeList.filter((a) => a.showMenuBar);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [brands, setBrands] = useState<{ id: number; name: string }[]>([]);
    const [openAccordion, setOpenAccordion] = useState<number | null>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const fetchBrands = async () => {
            const response = await getBrands();
            if (response.success && Array.isArray(response.data)) {
                setBrands(response.data);
            }
        };
        fetchBrands();
    }, []);

    const toggleAccordion = (index: number) => {
        setOpenAccordion(openAccordion === index ? null : index);
    };

    const sortedBrands = [...brands].sort((a, b) => {
        if (a.name === "Vaultex") return -1; // Vaultex first
        if (b.name === "Vaultex") return 1;
        if (a.name === "Honeywell") return 1; // Honeywell last
        if (b.name === "Honeywell") return -1;
        return 0; // keep original order for others
    });

    return (
        <>
            <div className="h-[136px] lg:h-[136px] min-[1750px]:h-[162px]"></div>
            <header className={`w-full left-0 right-0 top-0 z-20 bg-[#FFFFFF] transition-all duration-300 ease-in-out 
                        ${isSticky ? "fixed py-4 shadow-md" : "absolute py-8"} 
                        ${location.pathname !== "/" ? "border-b border-[#C3C3C3]" : ""}`}>
                <div className="w-full max-w-[1760px] mx-auto px-4">
                    <div className="flex flex-wrap items-center -mx-4">
                        <div className="w-2/6 max-w-full px-4">
                            <Link to="/" className="inline-block">
                                <img src={VaultexLogo} alt="Vaultex Logo" className={`${isSticky ? "max-w-[130px]" : "max-w-[150px] min-[1750px]:max-w-full"} transition-all duration-300 ease-in-out`} />
                            </Link>
                        </div>
                        <div className="w-2/3 max-w-full px-4">
                            <div className="hidden lg:flex justify-end items-center">
                                <ul className="flex justify-end items-center gap-[30px] xl:gap-[40px] 2xl:gap-[50px]">
                                    {navigationItems.map((item, index) => {
                                        const activeRoute = location.pathname === item.path;
                                        return (
                                            <li key={index} className="relative group py-5">
                                                <Link
                                                    to={item.path}
                                                    className={`group flex items-center gap-[10px] text-base xl:text-lg 2xl:text-xl ${activeRoute ? "font-semibold" : "font-normal"} leading-normal ${activeRoute ? "text-[#009FE3]" : "text-[#020303]"} hover:text-[#009FE3] transition-all duration-300 ease-in-out`}
                                                >
                                                    {item.menuLabel}
                                                    {item.menuLabel.toLowerCase() === "products" && brands.length > 0 && (
                                                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1.5L6 6.5L1 1.5" stroke="#009FE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                    )}
                                                </Link>
                                                {item.menuLabel.toLowerCase() === "products" && brands.length > 0 && (
                                                    <ul className="absolute top-full left-1/2 w-full min-w-[705px] bg-white shadow-[0_4px_8px_3px_rgba(0,0,0,0.10)] border-t border-[#020303] opacity-1 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 -translate-x-2/4 p-8">
                                                        <div className="flex items-center">
                                                            <div className="max-w-[190px]">
                                                                <img src={VaultexLogo} alt="Vaultex Logo" width={213} height={91} className="mb-4" />
                                                                <p className="text-sm font-normal leading-normal text-[#020303] mb-4">A Reliable End-to-End Safety Equipment Supplier in Dubai</p>
                                                                <Link to="/products?brand=34" className="block text-base font-normal leading-normal text-[#020303] border border-[#009FE3] py-[9px] px-[20px] hover:text-[#FFFFFF] hover:bg-[#009FE3] transition-all duration-300 ease-in-out text-center">View All Products</Link>
                                                            </div>
                                                            <div className="w-full px-12 ml-9 border-l border-[#CFCFCF]">
                                                                <ul className="flex flex-wrap -mx-4 gap-y-4">
                                                                    {sortedBrands.map((brand) => (
                                                                        <li key={brand.id} className="w-1/2">
                                                                            <Link
                                                                                to={`/products?brand=${brand.id}`}
                                                                                className="block text-base xl:text-lg 2xl:text-xl font-normal leading-normal text-[#020303] hover:text-[#009FE3] transition-all duration-300 ease-in-out px-4"
                                                                            >
                                                                                {brand.name}
                                                                            </Link>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                                <Link to="/top-brand" className="text-base xl:text-xl font-normal leading-normal text-[#020303] border-2 border-[#009FE3] py-[9px] px-[20px] xl:px-[28px] hover:text-[#FFFFFF] hover:bg-[#009FE3] ml-[30px] xl:ml-[40px] transition-all duration-300 ease-in-out">Brands</Link>
                            </div>
                            <div className="lg:hidden flex h-full items-center justify-end">
                                <Link to="/top-brand" className="text-sm sm:text-base xl:text-xl font-normal leading-normal text-[#020303] border-2 border-[#009FE3] py-[5px] px-[15px] xl:px-[28px] hover:text-[#FFFFFF] hover:bg-[#009FE3] mr-[20px] transition-all duration-300 ease-in-out">Top Brand</Link>
                                <button onClick={() => setMobileMenuOpen(true)}>
                                    <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Overlay Mobile Menu */}
            <div className={`fixed inset-0 bg-gray-500 bg-opacity-75 transition-all duration-500 z-20 ${mobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}>
                <div className={`absolute top-0 transition-all duration-500 bg-white h-full w-full ${mobileMenuOpen ? "left-0" : "-left-full"}`}>
                    <div className="flex justify-between items-center border-b-2 border-gray-200 p-4">
                        <img src={VaultexLogo} alt="Vaultex Logo" className="max-w-[150px] w-full" />
                        <button onClick={() => setMobileMenuOpen(false)} className="text-black hover:text-[#009EE1]">
                            <svg className="h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" fill="none">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Scrollable menu container */}
                    <div className="overflow-y-auto max-h-[calc(100vh-64px)] px-4">
                        <ul className="accordion">
                            {navigationItems.map((item, index) => {
                                const activeRoute = location.pathname === item.path;
                                if (item.menuLabel.toLowerCase() === "products" && brands.length > 0) {
                                    return (
                                        <li key={index} className="py-3 border-b border-gray-200">
                                            <div className="flex justify-between items-center w-full text-base font-normal leading-normal text-[#020303] hover:text-[#009FE3] transition-all duration-300 ease-in-out"
                                            >
                                                <Link to={item.path}
                                                    onClick={() => {
                                                        setMobileMenuOpen(false);
                                                    }}
                                                >Products</Link>
                                                <svg
                                                    onClick={() => {
                                                        toggleAccordion(index);
                                                    }}
                                                    className={`h-4 w-4 transform transition-transform duration-300 ${openAccordion === index ? "rotate-180" : ""}`}
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                >
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                            {openAccordion === index && (
                                                <ul className="pl-4 mt-2">
                                                    {sortedBrands.map((brand) => (
                                                        <li key={brand.id} className="py-2">
                                                            <Link
                                                                to={`/products?brand=${brand.id}`}
                                                                onClick={() => {
                                                                    setMobileMenuOpen(false);
                                                                    setOpenAccordion(null);
                                                                }}
                                                                className="text-base font-normal leading-normal text-[#020303] hover:text-[#009FE3] transition-all duration-300 ease-in-out block"
                                                            >
                                                                {brand.name}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    );
                                }
                                return (
                                    <li key={index} className="py-3 border-b border-gray-200">
                                        <Link
                                            to={item.path}
                                            onClick={() => setMobileMenuOpen(false)}
                                            className={`text-base ${activeRoute ? "font-semibold" : "font-normal"} leading-normal ${activeRoute ? "text-[#009FE3]" : "text-[#020303]"} hover:text-[#009FE3] transition-all duration-300 ease-in-out`}
                                        >
                                            {item.menuLabel}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Header;
